export const DEFAULT_RECEIPT_TAX_TEXT = 'GST included in total';
